import angular from "angular";
import registerFormComponent from "./register-form.component";

angular.module('registerForm', [registerFormComponent]);

export default 'registerForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/register-form/register-form.module.js